import { ApolloQueryResult } from '@apollo/client';
import {
  CartBrowsingCriteria,
  CartItem,
  Portfolio,
  RateSegment,
} from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import apolloClient from 'api/apolloClient';
import { GET_CATALOG, GET_PORTFOLIOS, GET_PORTFOLIOS_BY_ID } from 'api/queries/productServiceV2';
import { PortfolioRequest, Catalog } from 'types/productService';

export async function getPortfolios(
  request: PortfolioRequest,
): Promise<ApolloQueryResult<{ getPortfolios: Portfolio[] }>> {
  return apolloClient.query<{ getPortfolios: Portfolio[] }>({
    query: GET_PORTFOLIOS,
    variables: { request },
    fetchPolicy: 'no-cache',
  });
}

export async function getPortfoliosById(
  cartItems: CartItem[],
  lastUpdateBrowsingCriteria?: CartBrowsingCriteria,
): Promise<Portfolio[]> {
  const convertedInput = cartItems.map((cartItem) => {
    return {
      portfolioId: cartItem.portfolioId,
      browsingCriteria: cartItem.browsingCriteria,
    };
  });
  return (
    await apolloClient.query<{ getPortfoliosByIdWithBC: Portfolio[] }>({
      query: GET_PORTFOLIOS_BY_ID,
      variables: { cartItems: convertedInput, lastUpdateBC: lastUpdateBrowsingCriteria },
      fetchPolicy: 'no-cache',
    })
  ).data.getPortfoliosByIdWithBC;
}

export async function getCatalog(
  domainId: string,
  effectiveDate: string,
  rateSegment: RateSegment,
  state: string,
): Promise<ApolloQueryResult<{ getCatalog: Catalog }>> {
  return apolloClient.query<{ getCatalog: Catalog }>({
    query: GET_CATALOG,
    variables: { domainId, effectiveDate, rateSegment, state },
    fetchPolicy: 'no-cache',
  });
}
